import { waitForProcessTimePromise } from './common';

export function successProcessTimeClosedJobsRecruitersReport(data) {
  const updateDOM = () => {
    if (data.data.recruiters.length === 0) {
      $('.process-time-closed-jobs-recruiters-report-data-loading').addClass('is-hidden');
      $('.process-time-closed-jobs-recruiters-report-data-empty').removeClass('is-hidden');
      $('.process-time-closed-jobs-recruiters-data-table').html('');
    } else {
      $('.process-time-closed-jobs-recruiters-data-table').html(data.html);
      $('.process-time-closed-jobs-recruiters-report-data-loading').addClass('is-hidden');
      $('.process-time-closed-jobs-recruiters-report-data-empty').addClass('is-hidden');
      $('.process-time-closed-jobs-recruiters-data-table').removeClass('is-hidden');
    }
  };

  waitForProcessTimePromise('closedJobsRecruiters').then(updateDOM);
}

export function successProcessTimeClosedJobsCompanyTeamsReport(data) {
  const updateDOM = () => {
    if (data.data.company_teams.length === 0) {
      $('.process-time-closed-jobs-company-teams-report-data-loading').addClass('is-hidden');
      $('.process-time-closed-jobs-company-teams-report-data-empty').removeClass('is-hidden');
      $('.process-time-closed-jobs-company-teams-data-table').html('');
    } else {
      $('.process-time-closed-jobs-company-teams-data-table').html(data.html);
      $('.process-time-closed-jobs-company-teams-report-data-loading').addClass('is-hidden');
      $('.process-time-closed-jobs-company-teams-report-data-empty').addClass('is-hidden');
      $('.process-time-closed-jobs-company-teams-data-table').removeClass('is-hidden');
    }
  };

  waitForProcessTimePromise('closedJobsCompanyTeams').then(updateDOM);
}

export function successProcessTimeClosedJobsKpiReport(data) {
  const updateDOM = () => {
    $('.closed-jobs-tab-recruiters .kpi-wrapper').html(data.html);
    $('.closed-jobs-tab-recruiters .loading-wrapper').addClass('is-hidden');
    $('.closed-jobs-tab-recruiters .data-wrapper').removeClass('is-hidden');
  };

  waitForProcessTimePromise('closedJobsKpiRecruiters').then(updateDOM);
}

export function successProcessTimeClosedJobsKpiCompanyTeamsReport(data) {
  const updateDOM = () => {
    $('.closed-jobs-tab-company-teams .kpi-wrapper').html(data.html);
    $('.closed-jobs-tab-company-teams .loading-wrapper').addClass('is-hidden');
    $('.closed-jobs-tab-company-teams .data-wrapper').removeClass('is-hidden');
  };

  waitForProcessTimePromise('closedJobsKpiCompanyTeams').then(updateDOM);
}

export function errorProcessTimeClosedJobsRecruitersReport() {
  const updateDOM = () => {
    $('.process-time-closed-jobs-recruiters-report-data-loading').addClass('is-hidden');
    $('.process-time-closed-jobs-recruiters-report-data-empty').addClass('is-hidden');
    $('.process-time-closed-jobs-recruiters-data-table').addClass('is-hidden');
  };

  waitForProcessTimePromise('closedJobsRecruiters').then(updateDOM);
}

export function errorProcessTimeClosedJobsCompanyTeamsReport() {
  const updateDOM = () => {
    $('.process-time-closed-jobs-company-teams-report-data-loading').addClass('is-hidden');
    $('.process-time-closed-jobs-company-teams-report-data-empty').addClass('is-hidden');
    $('.process-time-closed-jobs-company-teams-data-table').addClass('is-hidden');
  };

  waitForProcessTimePromise('closedJobsCompanyTeams').then(updateDOM);
}

export function errorProcessTimeClosedJobsKpiReport() {
  const updateDOM = () => {
    $('.closed-jobs-tab-recruiters .loading-wrapper').addClass('is-hidden');
    $('.closed-jobs-tab-recruiters .data-wrapper').addClass('is-hidden');
    $('.closed-jobs-tab-recruiters').html('');
  };

  waitForProcessTimePromise('closedJobsKpiRecruiters').then(updateDOM);
}

export function errorProcessTimeClosedJobsKpiCompanyTeamsReport() {
  const updateDOM = () => {
    $('.closed-jobs-tab-company-teams .loading-wrapper').addClass('is-hidden');
    $('.closed-jobs-tab-company-teams .data-wrapper').addClass('is-hidden');
    $('.closed-jobs-tab-company-teams').html('');
  };

  waitForProcessTimePromise('closedJobsKpiCompanyTeams').then(updateDOM);
}
